function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable @typescript-eslint/no-empty-function */
import { ConnectedWallet, PORTKEYAA, PORTKEY_DISCOVER, enhancedLocalStorage, utils } from '@aelf-web-login/wallet-adapter-base';
import { setWalletInfo, clearWalletInfo, setLocking, setWalletType, clearWalletType, dispatch, setLoginError, clearLoginError } from "./store";
import { TelegramPlatform } from '@portkey/did-ui-react';
var isPortkeyApp = utils.isPortkeyApp;
var isDisconnectClicked = false;
var Bridge = /*#__PURE__*/function () {
  function Bridge(wallets, _ref) {
    var _this = this;
    var _ref$noCommonBaseModa = _ref.noCommonBaseModal,
      noCommonBaseModal = _ref$noCommonBaseModa === void 0 ? false : _ref$noCommonBaseModa;
    _classCallCheck(this, Bridge);
    _defineProperty(this, "_wallets", void 0);
    _defineProperty(this, "_activeWallet", void 0);
    _defineProperty(this, "_loginResolve", void 0);
    _defineProperty(this, "_loginReject", void 0);
    _defineProperty(this, "_logoutResolve", void 0);
    _defineProperty(this, "_logoutReject", void 0);
    _defineProperty(this, "_eventMap", {});
    _defineProperty(this, "_noCommonBaseModal", void 0);
    _defineProperty(this, "connect", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              _this._loginResolve = resolve;
              _this._loginReject = reject;
              if (TelegramPlatform.isTelegramPlatform()) {
                _this.autoLogin();
              } else if (isPortkeyApp()) {
                console.log('begin to execute onUniqueWalletClick in PortkeyApp');
                _this.onUniqueWalletClick('PortkeyDiscover');
              } else {
                _this.openLoginPanel();
              }
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(this, "doubleCheckDisconnect", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _this$activeWallet;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!isDisconnectClicked) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            isDisconnectClicked = true;
            _context2.next = 5;
            return (_this$activeWallet = _this.activeWallet) === null || _this$activeWallet === void 0 ? void 0 : _this$activeWallet.logout();
          case 5:
            _this.closeConfirmLogoutPanel();
            _this.closeLockPanel();
            isDisconnectClicked = false;
            _this._logoutResolve(true);
          case 9:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));
    _defineProperty(this, "disConnect", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", new Promise(function (resolve, reject) {
              _this._logoutResolve = resolve;
              _this._logoutReject = reject;
              var disConnectAsync = /*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
                  var _this$activeWallet2;
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        console.log('disconnect,isAAWallet:', _this.isAAWallet);
                        _context3.prev = 1;
                        if (!_this.isAAWallet) {
                          _context3.next = 11;
                          break;
                        }
                        if (!_this.activeWallet.noNeedForConfirm) {
                          _context3.next = 8;
                          break;
                        }
                        _context3.next = 6;
                        return _this.doubleCheckDisconnect();
                      case 6:
                        _context3.next = 9;
                        break;
                      case 8:
                        _this.openConfirmLogoutPanel();
                      case 9:
                        _context3.next = 14;
                        break;
                      case 11:
                        _context3.next = 13;
                        return (_this$activeWallet2 = _this.activeWallet) === null || _this$activeWallet2 === void 0 ? void 0 : _this$activeWallet2.logout();
                      case 13:
                        _this._logoutResolve(true);
                      case 14:
                        _context3.next = 20;
                        break;
                      case 16:
                        _context3.prev = 16;
                        _context3.t0 = _context3["catch"](1);
                        console.log(_context3.t0);
                        _this._logoutReject(false);
                      case 20:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3, null, [[1, 16]]);
                }));
                return function disConnectAsync() {
                  return _ref5.apply(this, arguments);
                };
              }();
              disConnectAsync();
            }));
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    })));
    _defineProperty(this, "getAccountByChainId", /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(chainId) {
        var _this$activeWallet3, _this$activeWallet4;
        var account;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!(!((_this$activeWallet3 = _this.activeWallet) !== null && _this$activeWallet3 !== void 0 && _this$activeWallet3.getAccountByChainId) || typeof _this.activeWallet.getAccountByChainId !== 'function')) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return", '');
            case 2:
              _context5.next = 4;
              return (_this$activeWallet4 = _this.activeWallet) === null || _this$activeWallet4 === void 0 ? void 0 : _this$activeWallet4.getAccountByChainId(chainId);
            case 4:
              account = _context5.sent;
              return _context5.abrupt("return", account);
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return function (_x) {
        return _ref6.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getWalletSyncIsCompleted", /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(chainId) {
        var _this$activeWallet5, _this$activeWallet6;
        var account;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!(!((_this$activeWallet5 = _this.activeWallet) !== null && _this$activeWallet5 !== void 0 && _this$activeWallet5.getWalletSyncIsCompleted) || typeof _this.activeWallet.getWalletSyncIsCompleted !== 'function')) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return", false);
            case 2:
              _context6.next = 4;
              return (_this$activeWallet6 = _this.activeWallet) === null || _this$activeWallet6 === void 0 ? void 0 : _this$activeWallet6.getWalletSyncIsCompleted(chainId);
            case 4:
              account = _context6.sent;
              return _context6.abrupt("return", account);
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      return function (_x2) {
        return _ref7.apply(this, arguments);
      };
    }());
    _defineProperty(this, "callSendMethod", /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(props) {
        var _this$activeWallet7, _this$activeWallet8;
        var rs;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!(!((_this$activeWallet7 = _this.activeWallet) !== null && _this$activeWallet7 !== void 0 && _this$activeWallet7.callSendMethod) || typeof _this.activeWallet.callSendMethod !== 'function')) {
                _context7.next = 2;
                break;
              }
              return _context7.abrupt("return", null);
            case 2:
              _context7.next = 4;
              return (_this$activeWallet8 = _this.activeWallet) === null || _this$activeWallet8 === void 0 ? void 0 : _this$activeWallet8.callSendMethod(props);
            case 4:
              rs = _context7.sent;
              return _context7.abrupt("return", rs);
            case 6:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      return function (_x3) {
        return _ref8.apply(this, arguments);
      };
    }());
    _defineProperty(this, "callViewMethod", /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(props) {
        var _this$activeWallet9, _this$activeWallet10;
        var rs;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!(!((_this$activeWallet9 = _this.activeWallet) !== null && _this$activeWallet9 !== void 0 && _this$activeWallet9.callViewMethod) || typeof _this.activeWallet.callViewMethod !== 'function')) {
                _context8.next = 2;
                break;
              }
              return _context8.abrupt("return", null);
            case 2:
              _context8.next = 4;
              return (_this$activeWallet10 = _this.activeWallet) === null || _this$activeWallet10 === void 0 ? void 0 : _this$activeWallet10.callViewMethod(props);
            case 4:
              rs = _context8.sent;
              return _context8.abrupt("return", rs);
            case 6:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      return function (_x4) {
        return _ref9.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getSignature", /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(params) {
        var _this$activeWallet11;
        var _this$activeWallet12, rs;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (!(!((_this$activeWallet11 = _this.activeWallet) !== null && _this$activeWallet11 !== void 0 && _this$activeWallet11.getSignature) || typeof _this.activeWallet.getSignature !== 'function')) {
                _context9.next = 2;
                break;
              }
              return _context9.abrupt("return", null);
            case 2:
              _context9.prev = 2;
              _context9.next = 5;
              return (_this$activeWallet12 = _this.activeWallet) === null || _this$activeWallet12 === void 0 ? void 0 : _this$activeWallet12.getSignature(params);
            case 5:
              rs = _context9.sent;
              return _context9.abrupt("return", rs);
            case 9:
              _context9.prev = 9;
              _context9.t0 = _context9["catch"](2);
              console.warn(_context9.t0);
              return _context9.abrupt("return", null);
            case 13:
            case "end":
              return _context9.stop();
          }
        }, _callee9, null, [[2, 9]]);
      }));
      return function (_x5) {
        return _ref10.apply(this, arguments);
      };
    }());
    _defineProperty(this, "onConnectedHandler", function (walletInfo) {
      var _this$activeWallet13;
      dispatch(setWalletInfo(walletInfo));
      dispatch(setWalletType((_this$activeWallet13 = _this.activeWallet) === null || _this$activeWallet13 === void 0 ? void 0 : _this$activeWallet13.name));
      dispatch(clearLoginError());
    });
    _defineProperty(this, "onDisConnectedHandler", function () {
      var isLocking = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      !isLocking && _this.unbindEvents();
      isLocking && _this.openLockPanel();
      _this.closeNestedModal();
      dispatch(clearWalletInfo());
      dispatch(clearWalletType());
      dispatch(clearLoginError());
    });
    _defineProperty(this, "onLockHandler", function () {
      if (TelegramPlatform.isTelegramPlatform()) {
        return;
      }
      _this.openLockPanel();
      dispatch(setLocking(true));
    });
    _defineProperty(this, "onConnectErrorHandler", function (err) {
      console.log('in error event', err, _this.activeWallet);
      if (!_this._noCommonBaseModal) {
        _this.closeLoginPanel();
        _this.closeNestedModal();
      }
      _this.unbindEvents();
      _this.closeLoadingModal();
      _this._loginReject(err);
      dispatch(clearWalletInfo());
      dispatch(clearWalletType());
      dispatch(setLoginError(err));
    });
    _defineProperty(this, "bindEvents", function () {
      console.log('bindEvents', _this.activeWallet);
      if (!_this.activeWallet) {
        return;
      }
      Object.entries(_this._eventMap).forEach(function (_ref11) {
        var _ref12 = _slicedToArray(_ref11, 2),
          k = _ref12[0],
          v = _ref12[1];
        _this.activeWallet.on(k, v);
      });
    });
    _defineProperty(this, "unbindEvents", function () {
      console.log('unbindEvents', _this.activeWallet);
      if (!_this.activeWallet) {
        return;
      }
      Object.entries(_this._eventMap).forEach(function (_ref13) {
        var _ref14 = _slicedToArray(_ref13, 2),
          k = _ref14[0],
          v = _ref14[1];
        _this.activeWallet.off(k, v);
      });
    });
    _defineProperty(this, "onUniqueWalletClick", /*#__PURE__*/function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(name) {
        var _this$_activeWallet, walletInfo;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.prev = 0;
              _this.openLoadingModal();
              _this._activeWallet = _this._wallets.find(function (ele) {
                return ele.name === name;
              });
              _this.bindEvents();
              _context10.next = 6;
              return (_this$_activeWallet = _this._activeWallet) === null || _this$_activeWallet === void 0 ? void 0 : _this$_activeWallet.login();
            case 6:
              walletInfo = _context10.sent;
              _this._loginResolve(walletInfo);
              _context10.next = 13;
              break;
            case 10:
              _context10.prev = 10;
              _context10.t0 = _context10["catch"](0);
              console.log('onUniqueWalletClick--', _context10.t0);
            case 13:
              _context10.prev = 13;
              if (!_this._noCommonBaseModal) {
                _this.closeLoginPanel();
              }
              _this.closeLoadingModal();
              return _context10.finish(13);
            case 17:
            case "end":
              return _context10.stop();
          }
        }, _callee10, null, [[0, 10, 13, 17]]);
      }));
      return function (_x6) {
        return _ref15.apply(this, arguments);
      };
    }());
    _defineProperty(this, "onPortkeyAAWalletLoginFinished", /*#__PURE__*/function () {
      var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(didWalletInfo) {
        var _this$activeWallet14, walletInfo;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.prev = 0;
              _this.openLoadingModal();
              _this._activeWallet = _this._wallets.find(function (item) {
                return item.name === PORTKEYAA;
              });
              _this.bindEvents();
              _context11.next = 6;
              return (_this$activeWallet14 = _this.activeWallet) === null || _this$activeWallet14 === void 0 ? void 0 : _this$activeWallet14.login(didWalletInfo);
            case 6:
              walletInfo = _context11.sent;
              _this._loginResolve(walletInfo);
              _context11.next = 13;
              break;
            case 10:
              _context11.prev = 10;
              _context11.t0 = _context11["catch"](0);
              console.log('onPortkeyAAWalletLoginFinishedError', _context11.t0);
            case 13:
              _context11.prev = 13;
              _this.closeLoadingModal();
              _this.closeLoginPanel();
              return _context11.finish(13);
            case 17:
            case "end":
              return _context11.stop();
          }
        }, _callee11, null, [[0, 10, 13, 17]]);
      }));
      return function (_x7) {
        return _ref16.apply(this, arguments);
      };
    }());
    _defineProperty(this, "onPortkeyAAUnLock", /*#__PURE__*/function () {
      var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(pin) {
        var _this$activeWallet15, _this$activeWallet16, walletInfo;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.prev = 0;
              _this.openLoadingModal();
              if (!(!((_this$activeWallet15 = _this.activeWallet) !== null && _this$activeWallet15 !== void 0 && _this$activeWallet15.onUnlock) || typeof _this.activeWallet.onUnlock !== 'function')) {
                _context12.next = 4;
                break;
              }
              return _context12.abrupt("return");
            case 4:
              _context12.next = 6;
              return (_this$activeWallet16 = _this.activeWallet) === null || _this$activeWallet16 === void 0 ? void 0 : _this$activeWallet16.onUnlock(pin);
            case 6:
              walletInfo = _context12.sent;
              console.log('onPortkeyAAUnLockSuccess----------', walletInfo);
              if (walletInfo) {
                _this.closeLoginPanel();
                dispatch(setLocking(false));
                dispatch(clearLoginError());
              }
              return _context12.abrupt("return", walletInfo);
            case 12:
              _context12.prev = 12;
              _context12.t0 = _context12["catch"](0);
              console.log('onPortkeyAAUnLockFail----------');
              return _context12.abrupt("return");
            case 16:
              _context12.prev = 16;
              _this.closeLoadingModal();
              return _context12.finish(16);
            case 19:
            case "end":
              return _context12.stop();
          }
        }, _callee12, null, [[0, 12, 16, 19]]);
      }));
      return function (_x8) {
        return _ref17.apply(this, arguments);
      };
    }());
    _defineProperty(this, "lock", function () {
      var _this$activeWallet17, _this$activeWallet18;
      if (!((_this$activeWallet17 = _this.activeWallet) !== null && _this$activeWallet17 !== void 0 && _this$activeWallet17.lock) || typeof _this.activeWallet.lock !== 'function') {
        return;
      }
      if (!_this.isAAWallet) {
        return;
      }
      (_this$activeWallet18 = _this.activeWallet) === null || _this$activeWallet18 === void 0 || _this$activeWallet18.lock();
      dispatch(setLocking(true));
    });
    this._noCommonBaseModal = noCommonBaseModal;
    this._wallets = wallets;
    this._activeWallet = undefined;
    this._loginResolve = function () {};
    this._loginReject = function () {};
    this._logoutResolve = function () {};
    this._logoutReject = function () {};
    this._eventMap = {
      connected: this.onConnectedHandler,
      disconnected: this.onDisConnectedHandler,
      lock: this.onLockHandler,
      error: this.onConnectErrorHandler
    };
    this.bindEvents();
  }
  _createClass(Bridge, [{
    key: "loginState",
    get: function get() {
      var _this$activeWallet19;
      return (_this$activeWallet19 = this.activeWallet) === null || _this$activeWallet19 === void 0 ? void 0 : _this$activeWallet19.loginState;
    }
  }, {
    key: "activeWallet",
    get: function get() {
      try {
        if (TelegramPlatform.isTelegramPlatform()) {
          this._activeWallet = this._wallets.find(function (item) {
            return item.name === PORTKEYAA;
          });
          return this._activeWallet;
        } else if (isPortkeyApp()) {
          this._activeWallet = this._wallets.find(function (item) {
            return item.name === PORTKEY_DISCOVER;
          });
          return this._activeWallet;
        } else {
          return this._activeWallet || this._wallets.find(function (item) {
            return item.name === enhancedLocalStorage.getItem(ConnectedWallet);
          });
        }
      } catch (e) {
        return undefined;
      }
    }
  }, {
    key: "isAAWallet",
    get: function get() {
      var _this$activeWallet20;
      return ((_this$activeWallet20 = this.activeWallet) === null || _this$activeWallet20 === void 0 ? void 0 : _this$activeWallet20.name) === PORTKEYAA;
    }
  }, {
    key: "autoLogin",
    value: function autoLogin() {}
  }, {
    key: "openLoginPanel",
    value: function openLoginPanel() {}
  }, {
    key: "closeLoginPanel",
    value: function closeLoginPanel() {}
  }, {
    key: "openLoadingModal",
    value: function openLoadingModal() {}
  }, {
    key: "closeLoadingModal",
    value: function closeLoadingModal() {}
  }, {
    key: "openLockPanel",
    value: function openLockPanel() {}
  }, {
    key: "closeLockPanel",
    value: function closeLockPanel() {}
  }, {
    key: "openConfirmLogoutPanel",
    value: function openConfirmLogoutPanel() {}
  }, {
    key: "closeConfirmLogoutPanel",
    value: function closeConfirmLogoutPanel() {}
  }, {
    key: "closeNestedModal",
    value: function closeNestedModal() {}
  }]);
  return Bridge;
}();
export { Bridge };